/**
 * Lao kip.
 */
export var LAK = {
  code: 'LAK',
  base: 10,
  exponent: 2
};